import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UtilityModule } from '@utility';
import { TeamsUiModule } from '@teams-ui-angular';
import { CodeBlockPopupComponent } from './code-block-popup.component';

/** Kept separate from SharedModule so lighter modules (e.g. attendee lab preview) can use it */
@NgModule({
  declarations: [CodeBlockPopupComponent],
  imports: [CommonModule, TranslateModule, UtilityModule, TeamsUiModule],
  exports: [CodeBlockPopupComponent],
})
export class CodeBlockModule {}
